import '../category.scss'; //import styles from "./Category.module.scss" if you want to use module

import React, { useMemo, useState } from 'react';

import { Tooltip } from 'react-tooltip';
import { debounce } from 'lodash';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import { Input, Select } from '../../components/primitives';

type CategoryFiltersProps = {
    type: string;
    search: any;
    setSearch: (search: string) => void;
    setSerialNumber: (serialNumber: string) => void;
    setType: (type: string) => void;
    serialNumber: string;
    applianceTypes: any;
};

export default function CategoryFilters(props: CategoryFiltersProps) {
    const [localSerialNumber, setLocalSerialNumber] = useState();

    const {
        setSerialNumber,
        setSearch,
        search,
        setType,
        type,
        applianceTypes,
    } = props;

    const delayedSetSerialNumber = useMemo(
        // Note: Yes, this should be a callback, but the react-hooks linter doesn't
        //       know how to deal with first argument of useCallback being a call to
        //       a function that return another function. So lets use useMemo to do
        //       the same in a way that react-hooks linter can analyze.
        () => debounce(setSerialNumber, 500),
        [setSerialNumber]
    );
    const { t } = useTranslation('templatePages');
    const { currentLocale } = usePageLocalization();

    return (
        <div className='filters'>
            <h4 className='filterName search'>{t('search')}</h4>
            <Input
                id='searchInput'
                className='filterInput'
                type='text'
                value={search}
                onChange={(value) => setSearch(value)}
            />
            <h4 className='filterName'>{t('product-type')}</h4>
            <Select
                className='filterInput'
                firstOption='Select a type'
                value={type}
                elements={applianceTypes.map(
                    (type: any) => type[currentLocale]
                )}
                onChange={(value: any) => setType(value)}
            />

            <h4 className='filterName'>
                {t('serial-number')}
                <span
                    id='serialInfo'
                    className='serialInfo iconfont iconfont-info'
                />
                <Tooltip
                    anchorSelect='#serialInfo'
                    content={t('serial-tooltip') as string}
                    style={{
                        width: '65%',
                    }}
                />
            </h4>
            <Input
                id='serialNumberInput'
                className='filterInput'
                type='number'
                value={localSerialNumber}
                onChange={(value: any) => {
                    setLocalSerialNumber(value);
                  
                }}
            />
        </div>
    );
}
